/* eslint-disable react/jsx-pascal-case */
import * as S from '../styles'
import TextField from '../../TextField'
import Select from '../../Select'
import { FormGroup } from '../../Form/styles'
import { useToast } from '../../../hooks/toast'
import { noSpecialChars, onlyNumber } from '../../../utils/utils'

import {
  cpfMask,
  dateMask,
  cellMask,
  fixPhoneMask,
  dddString,
  phoneString,
  dateString,
  nameMask,
  dateFromString,
  dateStringISO
} from '../masks'
import {
  birthVal,
  cellVal,
  cpfVal,
  emailVal,
  fieldVal,
  fixPhoneVal,
  nameVal,
  preNameVal
} from '../fieldValidator'
import cadastro from '../../../api/cadastro'
import { useContext, useEffect, useState } from 'react'
import { setUserInfo } from '../../../store/ducks/user'
import { useDispatch } from 'react-redux'
import { UserContext } from '../../../contexts/UserContext'

const Step2 = ({ userData, cancelar, refreshUserData, refresh }) => {
  const { addToast } = useToast()
  const [localData, setLocalData] = useState({})
  const { user, setUser } = useContext(UserContext)

  const dispatch = useDispatch()

  const onChange = (value, field) => {
    setLocalData((prev) => ({
      ...prev,
      [field]: value
    }))
  }

  useEffect(() => {
    setLocalData(userData)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const save = async () => {
    const msg = fieldVal(
      [
        localData.email,
        localData.nome,
        localData.apelido,
        localData.cpf,
        localData.nascimento,
        localData.telCel,
        localData.telRes,
        localData.telCom
      ],
      [
        emailVal,
        nameVal,
        preNameVal,
        cpfVal,
        birthVal,
        cellVal,
        fixPhoneVal,
        fixPhoneVal
      ]
    )
    if (msg !== '') {
      return addToast({
        type: 'error',
        title: 'Preenchimentos de campo inválidos'
      })
    }

    const formBody = {
      id: localData.id,
      apelido: localData.apelido,
      nome: localData.nome,
      dataNascimento:
        localData.nascimento === undefined
          ? userData.dataNascimento
          : dateString(localData.nascimento),
      sexo: localData.sexo,
      rg: '',
      telefoneResidencialDDD:
        localData.telRes === ''
          ? null
          : dddString(localData.telRes || userData.telRes),
      telefoneResidencialNumero:
        localData.telRes === ''
          ? null
          : phoneString(localData.telRes || userData.telRes),
      telefoneCelularDDD: dddString(localData.telCel || userData.telCel),
      telefoneCelularNumero: phoneString(localData.telCel || userData.telCel),
      telefoneComercialDDD:
        localData.telCom === ''
          ? null
          : dddString(localData.telCom || userData.telCom),
      telefoneComercialNumero:
        localData.telCom === ''
          ? null
          : phoneString(localData.telCom || userData.telCom),
      // telefoneCelularDDD: dddString(localData.telCel),
      // telefoneCelularNumero: phoneString(localData.telCel),
      // telefoneComercialDDD: dddString(localData.telCom),
      // telefoneComercialNumero: phoneString(localData.telCom),
      telefoneComercialRamal: localData.telefoneComercialRamal
    }

    // receberNovidades: localData.receberNovidades || false,
    // receberEmailMarketing: localData.receberEmailMarketing || false
    try {
      // console.log('body', formBody)
      const response = await cadastro.updatePF(formBody)

      if (response.ok) {
        addToast({
          type: 'success',
          title: 'Dados alterados com sucesso'
        })
        refreshUserData(!refresh)
        setUser({ ...user, ...formBody })
        dispatch(setUserInfo(formBody))
        return cancelar()
      } else {
        return addToast({
          type: 'error',
          title: 'Erro ao alterar os dados do usuário'
        })
      }
    } catch (e) {}
  }

  return (
    <div>
      <S.WrapperExibition>
        <S.col_group>
          <S.col12>
            <S.form_group>
              <S.label>
                E-mail
                <S.o>*</S.o>
              </S.label>
              <TextField
                maxlength={50}
                name="email"
                disabled
                placeholder="Email"
                value={localData.email ? localData.email : userData.email}
                onChange={(e) => onChange(e.target.value, 'email')}
              />
            </S.form_group>
          </S.col12>

          <S.box>
            <S.col8>
              <S.form_group>
                <S.label>
                  Nome <S.o>*</S.o>
                </S.label>
                <TextField
                  maxlength={50}
                  name="nome"
                  placeholder="Nome"
                  value={
                    localData.nome === undefined
                      ? userData.nome
                      : localData.nome
                  }
                  error={nameVal(localData.nome)}
                  onChange={(e) =>
                    onChange(nameMask(e.target.value.trimStart()), 'nome')
                  }
                  onBlur={(e) => {
                    onChange(
                      e.target.value.trimEnd().replace(/  +/g, ' '),
                      'nome'
                    )
                  }}
                />
              </S.form_group>
            </S.col8>
            <S.col4>
              <S.form_group>
                <S.label>
                  Como deseja ser chamado(a)<S.o>*</S.o>
                </S.label>
                <TextField
                  maxlength={20}
                  name="apelido"
                  placeholder="Apelido"
                  value={
                    localData.apelido === undefined
                      ? userData.apelido
                      : localData.apelido
                  }
                  error={preNameVal(localData.apelido)}
                  onChange={(e) => {
                    onChange(
                      noSpecialChars(e.target.value.trimStart()),
                      'apelido'
                    )
                  }}
                  onBlur={(e) => {
                    onChange(
                      e.target.value.trimEnd().replace(/  +/g, ' '),
                      'apelido'
                    )
                  }}
                />
              </S.form_group>
            </S.col4>
          </S.box>

          <S.box>
            <S.col4>
              <S.form_group>
                <S.label>
                  CPF <S.o>*</S.o>
                </S.label>
                <TextField
                  disabled
                  name="cpf"
                  placeholder="CPF"
                  value={cpfMask(
                    localData.cpf === undefined ? userData.cpf : localData.cpf
                  )}
                  error={cpfVal(localData.cpf ? localData.cpf : userData.cpf)}
                  onChange={(e) => onChange(cpfMask(e.target.value), 'cpf')}
                />
              </S.form_group>
            </S.col4>
            <S.col4>
              <FormGroup>
                <Select
                  options={[
                    { value: 'm', label: 'Masculino' },
                    { value: 'f', label: 'Feminino' }
                  ]}
                  label="Sexo"
                  labelFor="Sexo"
                  value={localData.sexo}
                  onChange={(e) => onChange(e.currentTarget.value, 'sexo')}
                />
              </FormGroup>
            </S.col4>
            <S.col4>
              <S.form_group>
                <S.label>
                  Data de Nascimento <S.o>*</S.o>
                </S.label>
                <TextField
                  name="dataNascimento"
                  placeholder="Data de Nascimento"
                  value={
                    localData.dataNascimento === undefined
                      ? dateFromString(userData.dataNascimento)
                      : dateMask(localData.nascimento)
                  }
                  // error={birthVal(localData.nascimento)}
                  error={birthVal(
                    localData.nascimento !== undefined
                      ? localData.nascimento
                      : userData.nascimento
                  )}
                  onChange={(e) =>
                    onChange(dateMask(e.target.value), 'nascimento')
                  }
                />
              </S.form_group>
            </S.col4>
          </S.box>
          <S.box>
            <S.col4>
              <S.form_group>
                <S.label>
                  Telefone Celular <S.o>*</S.o>
                </S.label>
                <TextField
                  name="telCel"
                  placeholder="Telefone Celular"
                  value={cellMask(
                    localData.telCel === undefined
                      ? userData.telCel
                      : localData.telCel
                  )}
                  error={cellVal(localData.telCel)}
                  onChange={(e) => onChange(cellMask(e.target.value), 'telCel')}
                />
              </S.form_group>
            </S.col4>
            <S.col4>
              <S.form_group>
                <S.label>Telefone Residencial</S.label>
                <TextField
                  name="telRes"
                  placeholder="Telefone Residencial"
                  value={fixPhoneMask(
                    localData.telRes === undefined
                      ? userData.telRes
                      : localData.telRes
                  )}
                  error={fixPhoneVal(
                    localData.telRes ? localData.telRes : userData.telRes
                  )}
                  onChange={(e) =>
                    onChange(fixPhoneMask(e.target.value), 'telRes')
                  }
                />
              </S.form_group>
            </S.col4>
            <S.col3 className="col-ramal">
              <S.form_group>
                <S.label>Telefone Comercial</S.label>
                <TextField
                  name="telCom"
                  placeholder="Telefone Comercial"
                  value={fixPhoneMask(
                    localData.telCom === undefined
                      ? userData.telCom
                      : localData.telCom
                  )}
                  error={fixPhoneVal(
                    localData.telCom ? localData.telCom : userData.telCom
                  )}
                  onChange={(e) =>
                    onChange(fixPhoneMask(e.target.value), 'telCom')
                  }
                />
              </S.form_group>
            </S.col3>
            <S.col1 className="col-ramal">
              <S.form_group>
                <S.label>Ramal</S.label>
                <TextField
                  name="telefoneComercialRamal"
                  value={
                    localData.telefoneComercialRamal === undefined
                      ? userData.telefoneComercialRamal
                      : localData.telefoneComercialRamal
                  }
                  // error={fixPhoneVal(
                  //   localData.telCom ? localData.telCom : userData.telCom
                  // )}
                  onChange={(e) => {
                    onChange(e.target.value, 'telefoneComercialRamal')
                  }}
                />
              </S.form_group>
            </S.col1>
          </S.box>
          <S.perfilBoxFooter>
            <S.AdvanceButton
              onClick={() => {
                save()
              }}
            >
              Salvar dados
            </S.AdvanceButton>
            <S.button onClick={() => cancelar()}>Cancelar</S.button>
          </S.perfilBoxFooter>
        </S.col_group>
      </S.WrapperExibition>
    </div>
  )
}

export default Step2
